import { create } from "zustand";

/**
 * 2026-04-25: 제련소·각인 의식 진입을 글로벌 스토어로 노출.
 *   - WeeklyTurnScene 의 우상단 툴바
 *   - PortraitAnchor 의 인물 메뉴 (HUD)
 *   양쪽에서 동일 ForgePickerOverlay 를 띄울 수 있게 한다.
 *
 * ForgePickerOverlay 자체는 HudLayer 등 전역 위치에서 단 한 번 렌더되며,
 * 이 store 의 mode 가 null 이 아닐 때만 표시된다.
 */

export type ForgePickerMode = "refine" | "engrave";

interface ForgePickerState {
    mode: ForgePickerMode | null;
    open: (mode: ForgePickerMode) => void;
    close: () => void;
}

export const useForgePickerStore = create<ForgePickerState>((set) => ({
    mode: null,
    open: (mode) => set({ mode }),
    close: () => set({ mode: null }),
}));
